export default __webpack_public_path__ + "static/media/head04_zh_cn_sp.ea7bb831.png";